<template>
  <main class="mt-3 admin-page">
  <div class="pl-1 text-center">

    <!-- 상단 고정 액션바 -->
    <div class="topbar mb-3">
      <div class="topbar-left">
        <h2 class="page-title">예 약 관 리</h2>
        <span class="badge-pill badge-nonmember" v-if="this.reserveInfo.resMFlag === 'N'">비회원</span>
        <span class="badge-pill badge-membership" v-else-if="this.reserveInfo.memShip === 'N'">멤버십</span>
      </div>
      <div class="topbar-right">
        <button type="button" class="btn btn-calc" @click="callWinCalc();">
          <i class="bi bi-calculator-fill"></i> 계산기
        </button>
        <button type="button" class="btn btn-save" @click="dataBaseTransaction('U','R');">
          <i class="bi bi-pencil-square"></i> 예약저장
        </button>
      </div>
    </div>

    <div class="container-fluid">

      <!-- ============ 요청정보 ============ -->
      <div class="section-card">
        <div class="section-head">
          <i class="bi bi-clipboard-check"></i>
          <span>요청정보</span>
        </div>

        <table class="table table-bordered align-middle w-100 h-auto data-table">
          <tbody>
            <tr>
              <th class="col-2">예약코드</th>
              <td class="col-4"><span class="ref-value ref-code">{{this.reqRsvCode}}</span></td>
              <th class="col-2">상태</th>
              <td class="col-4">
                <div class="input-group flex-nowrap align-items-center">
                  <select class="form-select form-select-sm field-editable" aria-label=".form-select-sm" ref="sel_procCode" v-model="this.reserveInfo.reqStatus" @change="changeProcCode(this.reserveInfo.reqStatus)">
                    <option :value="rProcCode.procCode" :key=i v-for="(rProcCode,i) in rProc">({{ rProcCode.procCode }}) {{ rProcCode.procName }} </option>
                  </select>
                  <span class="status-chip" :class="'status-' + this.reserveInfo.reqStatus">
                    {{ (rProc.find(r => r.procCode === this.reserveInfo.reqStatus) || {}).procName || this.reserveInfo.reqStatus }}
                  </span>

                  <!-- 취소사유 -->
                  <select class="form-select form-select-sm field-editable field-warn" aria-label=".form-select-sm" ref="sel_cxlFlag" v-model="this.reserveInfo.cxlFlag" @change="changeCxlCode(this.reserveInfo.cxlFlag)" v-if="this.reserveInfo.reqStatus === 'CX'">
                    <option :value="cx.procCode" :key=i v-for="(cx,i) in cxlFlagList">({{ cx.procCode }}) {{cx.procName}}</option>
                  </select>

                  <button type="button" class="btn btn-point-add" @click="pSetAside();" v-if="reserveInfo.memShip === 'N' && reserveInfo.reqStatus === 'CO'">
                    <i class="bi bi-coin"></i> 포인트적립
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <th><i class="bi bi-asterisk req-mark"></i>예약자/연락처</th>
              <td class="col-md-4">
                <div class="input-group">
                  <input type="text" class="form-control form-control-sm field-editable" style="font-size: small" ref="txt_reqName" v-model="reserveInfo.reqName" placeholder="예약자명">
                  <input type="text" class="form-control form-control-sm field-editable" style="font-size: small" ref="txt_reqTelNo" v-model="reserveInfo.reqTelNo" placeholder="연락처">
                  <input type="text" class="form-control form-control-sm field-editable" style="font-size: small" ref="txt_conEmail" v-model="reserveInfo.conEmail" placeholder="이메일">
                </div>
              </td>
              <th><i class="bi bi-asterisk req-mark"></i>신청일</th>
              <td class="col-md-4">
                <input type="date" class="form-control field-readonly" ref="txt_reqDate" v-model="reserveInfo.reqDate" disabled>
              </td>
            </tr>
            <tr>
              <th><i class="bi bi-asterisk req-mark"></i>출발/여행지역</th>
              <td class="col-4">
                <div class="input-group">
                  <select class="form-select form-select-sm field-readonly text-primary" aria-label=".form-select-sm" ref="sel_ctCd" v-model="this.productInfo.ctCd" disabled>
                    <option :value="cityList[i].baseCode" :key=i v-for="(baseCode,i) in cityList">{{cityList[i].codeNameKor}}</option>
                  </select>
                  <select class="form-select form-select-sm field-readonly" aria-label=".form-select-sm" ref="sel_ntCd" disabled>
                    <option :value="this.productInfo.ntCd">{{this.productInfo.ntName}}</option>
                  </select>
                  <select class="form-select form-select-sm field-readonly" aria-label=".form-select-sm" ref="sel_arCd" disabled>
                    <option :value="this.productInfo.arCd">{{this.productInfo.arName}}</option>
                  </select>
                </div>
              </td>
              <th class="col-md-2"><i class="bi bi-asterisk req-mark"></i>여정기간</th>
              <td class="col-md-4">
                <div class="input-group">
                  <span class="input-group-text" id="basic-addon1">출국</span>
                  <input type="date" class="form-control field-readonly" style="font-size:small" ref="txt_dptDate" v-model="reserveInfo.reqDptDate" readonly>
                  <span class="input-group-text" id="basic-addon1">귀국</span>
                  <input type="date" class="form-control field-readonly" style="font-size:small" ref="txt_rtnDate" v-model="reserveInfo.reqRtnDate" readonly>
                </div>
              </td>
            </tr>
            <tr>
              <th class="col-md-2">출발불가일(공시)</th>
              <td class="col-md-4">
                <textarea class="form-control field-readonly text-danger" placeholder="(예시) 2022-12-25, 2022-12-26, 매주 화요일" ref="txt_unableDpDate" id="floatingTextarea" style="height:80px; font-size:smaller;"
                  v-model="productInfo.unableDpDate" maxlength="200" disabled></textarea>
              </td>
              <th class="col-md-2">상품문의</th>
              <td class="col-md-4">
                <textarea class="form-control field-readonly" placeholder="200자 이내" ref="txt_nContent" id="floatingTextarea" style="height:80px; font-size:smaller;" v-model="this.reserveInfo.reqRemarks" maxlength="200" readonly></textarea>
              </td>
            </tr>

            <tr>
              <th class="col-md-2">상품옵션</th>
              <td class="text-secondary text-start col-md-4 opt-cell">
                <div class="opt-group">
                  <div class="opt-label opt-label-select">선택형 옵션</div>
                  <div v-if="this.selOptInfo.length > 0">
                    <div class="opt-line" :key="i" v-for="(so, i) in this.selOptInfo">
                        - {{ so.optName }}&nbsp;&nbsp;({{ so.qty_opt }}개, <span class="text-danger fw-bold">{{ this.getCurrencyFormat(so.optPrice * so.qty_opt) }}</span> 원)
                    </div>
                  </div>
                  <div v-else class="opt-empty">선택형 옵션이 없습니다</div>
                  <hr>
                  <div class="opt-label opt-label-direct">직접형 옵션</div>
                  <div v-if="this.dirOptInfo.length > 0">
                    <div class="opt-line" :key="j" v-for="(dio, j) in this.dirOptInfo">
                        - {{ dio.odName }}&nbsp;&nbsp;(<span class="text-primary fw-bold">{{ dio.odValue }}</span>)
                      </div>
                  </div>
                  <div v-else class="opt-empty">직접형 옵션이 없습니다</div>
                </div>
              </td>

              <th class="col-md-2">추가상품</th>
              <td class="col-md-4 text-start opt-cell">
                <div v-if="this.addPdtInfo.length <=0" class="opt-empty">구매된 추가상품이 없습니다.</div>
                <div v-else>
                  <div class="opt-line" :key="i" v-for="(so, i) in this.addPdtInfo">
                    {{ so.addPdtName }} ▶ {{ so.addPdtValue }}&nbsp;&nbsp;({{ so.addQty }}개, <span class="text-danger fw-bold">{{ this.getCurrencyFormat(so.addPrice * so.addQty) }}</span> 원)
                  </div>
                </div>
              </td>
            </tr>

            <tr>
              <th class="col-md-2">
                <div>적립포인트 <span class="text-muted-note">(비회원제외)</span></div>
                <div><small class="text-danger">(멤버십은 추가적립포함)</small></div>
              </th>
              <td class="col-md-4">
                <div class="input-group">
                  <input type="number" class="form-control text-end field-editable" ref="rePoint" v-model="reserveInfo.rePoint">
                  <select class="form-select form-select-md field-editable" aria-label=".form-select-md" v-model="reserveInfo.rePointMethod">
                    <option value="A" id="rePointMethod" selected>원</option>
                    <option value="P" id="rePointMethod">%</option>
                  </select>
                </div>
              </td>
              <th class="col-md-2">상품가격</th>
              <td class="col-md-4">
                <!-- [수정] 결제상태와 무관하게 항상 할인 전 원금액 표시 -->
                <div class="price-highlight">{{ this.getCurrencyFormat(this.totPrice_org) }} 원</div>
              </td>
            </tr>
            <tr>
              <th class="col-md-2"></th>
              <td class="col-md-4"></td>
              <th class="col-md-2">포인트사용</th>
              <td class="col-md-4">
                <div class="input-group" v-if="this.reserveInfo.payPoint > 0">
                  <span class="ref-value">{{this.getCurrencyFormat(this.availPoint)}} P중 ({{this.getCurrencyFormat(this.reserveInfo.payPoint)}} P)사용</span>
                </div>
              </td>
            </tr>
            <tr>
              <th class="col-md-2">기존업무코멘트</th>
              <td class="col-md-4">
                <textarea class="form-control field-readonly" ref="txt_orgComment" id="floatingTextarea" style="height:110px; font-size:smaller;"
                  v-model="this.reserveInfo.oldComment" maxlength="1000" disabled></textarea>
              </td>
              <th class="col-md-2">업무코멘트</th>
              <td class="col-md-4">
                <textarea class="form-control field-editable" placeholder="250자 이내" ref="txt_newComment" id="floatingTextarea" style="height:110px; font-size:smaller;"
                  v-model="this.reserveInfo.newComment" maxlength="250"></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ============ 결제내역 ============ -->
      <div class="section-card" v-if="this.reserveInfo.reqStatus == 'PY' || (this.reserveInfo.reqStatus == 'RP' && this.userPayInfo.padiId != '') || this.reserveInfo.reqStatus == 'CO' || this.reserveInfo.reqStatus == 'CX' || this.reserveInfo.reqStatus == 'WP'">
        <div class="section-head section-head-payment">
          <i class="bi bi-credit-card"></i>
          <span>결제내역</span>
        </div>

        <table class="table table-bordered align-middle w-100 h-auto text-center data-table">
          <tbody>
            <tr>
              <th class="col-md-2">결제내역</th>
              <td class="col-md-3">
                <div class="text-start pay-block">
                  <p>대금총액: <b>{{ getCurrencyFormat(this.totPrice_org) }}</b></p>
                  <p>청구액: <b>{{ getCurrencyFormat(this.userPayInfo.actualPayAmount) }}</b></p>
                  <hr>
                  <p class="ps-3">- 실결제액({{ this.userPayInfo.fName }}): {{ getCurrencyFormat(this.userPayInfo.actualPayAmount) }}</p>
                  <p class="ps-3" v-if="reserveInfo.memShip === 'N'">- 멤버십할인: {{ getCurrencyFormat(reserveInfo.memDCAmt) }}</p>
                  <p class="ps-3">- 포인트결제: {{ getCurrencyFormat(this.totPaidPoint) }}</p>
                  <p class="ps-3">- 쿠폰결제: {{ getCurrencyFormat(this.payCouponAmt + this.payCouponAmt2) }}</p>
                </div>
              </td>
              <td class="col-md-3" v-if="this.balance > 0">
                <div class="text-start pay-block">
                  <p>잔여대금: <b class="text-danger">{{ getCurrencyFormat(this.balance) }}</b></p>
                  <span class="badge-pill badge-pending" v-if="userPayInfo.reqPayBalance === 'Y' && reserveInfo.totalPrice != userPayInfo.actualPayAmount">
                    잔여대금 청구 중
                  </span>
                  <hr>
                  <div class="text-center"><button class="btn btn-request-balance" @click="payBalance()">잔여대금청구</button></div>
                </div>
              </td>
              <th class="col-md-2">
                결제 히스토리
                <p v-if="totalPay <= 0" class="hint-danger">2024-05-13 이전결제는 히스토리 제공X</p>
              </th>
              <td class="col-md-3">
                <div class="text-start pay-history">
                  <p v-if="fPayFlag === 'N' && p1PayAmt > 0">
                    <i class="bi bi-stop-fill text-warning"></i> 예약금결제: {{ getCurrencyFormat(p1PayAmt) }}
                    <span v-if="p1PayDate != ''" class="hist-date"> ( {{ p1PayDate }} )</span>
                  </p>
                  <p v-else-if="fPayFlag === 'Y' && p1PayAmt > 0">
                    <i class="bi bi-stop-fill text-warning"></i> 전액결제: {{ getCurrencyFormat(p1PayAmt) }}
                    <span v-if="p1PayDate != ''" class="hist-date"> ( {{ p1PayDate }} )</span>
                  </p>

                  <p v-if="payPointAmt != '' && payPointAmt > 0">
                    <i class="bi bi-stop-fill text-success"></i> 포인트결제: {{ getCurrencyFormat(payPointAmt) }}
                    <span v-if="payPointDate != ''" class="hist-date"> ( {{ payPointDate }} )</span>
                  </p>
                  <p v-if="payCouponAmt != '' && payCouponAmt > 0">
                    <i class="bi bi-stop-fill text-success"></i> 쿠폰결제: {{ getCurrencyFormat(this.payCouponAmt) }}
                    <span v-if="this.payCouponDate != ''" class="hist-date"> ( {{ this.payCouponDate }} )</span>
                  </p>

                  <p v-if="p2PayAmt != '' && p2PayAmt > 0">
                    <i class="bi bi-stop-fill text-danger"></i> 잔여금결제: {{ getCurrencyFormat(p2PayAmt) }}
                    <span v-if="p2PayDate != ''" class="hist-date"> ( {{ p2PayDate }} )</span>
                  </p>

                  <p v-if="this.payPointAmt2 != '' && this.payPointAmt2 > 0">
                    <i class="bi bi-stop-fill text-success"></i> 포인트결제: {{ getCurrencyFormat(this.payPointAmt2) }}
                    <span v-if="payPointDate2 != ''" class="hist-date"> ( {{ payPointDate2 }} )</span>
                  </p>
                  <p v-if="this.payCouponAmt2 != '' && this.payCouponAmt2 > 0">
                    <i class="bi bi-stop-fill text-success"></i> 쿠폰결제: {{ getCurrencyFormat(this.payCouponAmt2) }}
                    <span v-if="payCouponDate2 != ''" class="hist-date"> ( {{ payCouponDate2 }} )</span>
                  </p>

                  <p v-if="reserveInfo.memShip === 'N'">
                    <i class="bi bi-stop-fill text-secondary"></i> 멤버십할인: {{ getCurrencyFormat(reserveInfo.memDCAmt) }}
                  </p>
                  
                  <hr>
                  <span class="hist-total" v-if="this.totalPay > 0">합계: {{ getCurrencyFormat(this.totalPay) }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ============ 상품정보 ============ -->
      <div class="section-card">
        <div class="section-head">
          <i class="bi bi-bag-check"></i>
          <span>상품정보</span>
        </div>

        <table class="table table-bordered align-middle w-100 h-auto text-center data-table">
          <tbody>
            <tr>
              <th class="col-md-2">상품코드</th>
              <td class="col-md-4"><span class="ref-value ref-code">{{this.productCode}}</span></td>
              <th scope="row" class="col-md-1">상품(속성)</th>
              <td class="col-md-4">
                <div class="form-check-inline small" :key=i v-for="(baseCode,i) in this.sRoute">
                  <div v-if="this.sRoute[i].baseCode === this.salesRoute">
                    <label class="form-check-label text-danger" role="switch" for="flexRadioDefault1">
                      <b>{{ this.sRoute[i].codeNameKor }}</b>
                    </label>
                  </div>
                  <div v-else>
                    <label class="form-check-label text-secondary" for="flexRadioDefault1">
                      {{ this.sRoute[i].codeNameKor }}
                    </label>
                  </div>
                </div>
                &nbsp;&nbsp;(
                <span v-if="productInfo.tripProp === 'F'" class="text-info"><b><i>{{productInfo.tripProp}}</i></b></span>
                <span v-if="productInfo.tripProp === 'D'" class="text-warning"><b><i>{{productInfo.tripProp}}</i></b></span>
                )
              </td>
            </tr>
            <tr>
              <th class="col-md-2"><i class="bi bi-asterisk req-mark"></i>상품(국문)</th>
              <td class="col-md-4"><input type="text" class="form-control field-readonly" ref="txt_pdtNameKor" style="font-size:smaller;"  v-model="productInfo.pdtNameKor" readonly></td>
              <th class="col-md-2">상품(영문)</th>
              <td class="col-md-4"><input type="text" class="form-control field-readonly" ref="txt_pdtNameKor" style="font-size:smaller;" v-model="productInfo.pdtNameEng" readonly></td>
            </tr>
            <tr>
              <th class="col-md-2"><i class="bi bi-asterisk req-mark"></i>출발/여행국</th>
              <td class="col-md-4">
                <div class="input-group">
                  <input type="text" class="form-control field-readonly text-success" ref="txt_ctCd" v-model="productInfo.ctName" readonly>
                  <input type="text" class="form-control field-readonly" ref="txt_ntCd" v-model="productInfo.ntName" readonly>
                </div>
              </td>
              <th class="col-md-2"><i class="bi bi-asterisk req-mark"></i>지역/체류일</th>
              <td class="col-md-4">
                <div class="input-group">
                  <input type="text" class="form-control field-readonly" ref="txt_arCd" v-model="productInfo.arName" readonly>
                  <input type="number" min=0 class="form-control field-readonly text-end text-small" ref="txt_stayCnt" v-model="productInfo.stayCnt" readonly>
                </div>
              </td>
            </tr>
            <tr>
              <th class="col-md-2"><i class="bi bi-asterisk req-mark"></i>여행/유효기간</th>
              <td class="col-md-4">
                <div class="input-group">
                  <span class="input-group-text" id="basic-addon1">개시</span>
                  <input type="date" class="form-control field-readonly" ref="txt_salesStart" v-model="productInfo.tripStart" readonly>
                  <span class="input-group-text" id="basic-addon1">종료</span>
                  <input type="date" class="form-control field-readonly" ref="txt_salesEnd" v-model="productInfo.tripEnd" readonly>
                </div>
              </td>
              <th class="col-md-2"><i class="bi bi-asterisk req-mark"></i>판매기간</th>
              <td class="col-md-4">
                <div class="input-group">
                  <span class="input-group-text" id="basic-addon1">개시</span>
                  <input type="date" class="form-control field-readonly" ref="txt_salesEnd" v-model="productInfo.salesStart" readonly>
                  <span class="input-group-text" id="basic-addon1">종료</span>
                  <input type="date" class="form-control field-readonly" ref="txt_salesEnd" v-model="productInfo.salesEnd" readonly>
                </div>
              </td>
            </tr>
            <tr>
              <th class="col-md-2">명목가격</th>
              <td class="col-md-4">
                <div class="input-group">
                  <input type="number" class="form-control field-readonly text-end" ref="txt_unitPrice" v-model="productInfo.nominalAmt" readonly>
                  <span class="input-group-text">원</span>
                </div>
              </td>
              <th class="col-md-2"><i class="bi bi-asterisk req-mark"></i>기본마진</th>
              <td class="col-md-4">
                <div class="input-group">
                  <input type="number" class="form-control field-readonly text-end" ref="txt_basicMargin" v-model="productInfo.basicMargin" readonly>
                  <select class="form-select form-select-md field-readonly" aria-label=".form-select-md" v-model="productInfo.marginMethod" readonly>
                    <option value="A" id="promoMethod" selected>원</option>
                    <option value="P" id="promoMethod">%</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th class="col-md-2">부가세</th>
              <td class="col-md-4">
                <div class="input-group">
                  <input type="text" class="form-control field-readonly text-end" ref="txt_vatPrice" v-model="productInfo.vatPrice" readonly>
                  <span class="input-group-text">%</span>
                </div>
              </td>
              <th class="col-md-2">제공포인트</th>
              <td class="col-md-4">
                <div class="input-group">
                  <input type="number" class="form-control field-readonly text-end" ref="txt_userPoint" v-model="productInfo.userPoint" readonly>
                  <select class="form-select form-select-md field-readonly" aria-label=".form-select-md" v-model="productInfo.userPointMethod" readonly>
                    <option value="A" id="userPointMethod" selected>점</option>
                    <option value="P" id="userPointMethod">%</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th class="col-md-2">출발불가일</th>
              <td class="col-md-4">
                <textarea class="form-control field-readonly" placeholder="(예시) 2022-12-25, 2022-12-26, 매주 화요일" ref="txt_unableDpDate" id="floatingTextarea" style="height:110px; font-size:smaller;"
                  v-model="productInfo.unableDpDate" maxlength="200" readonly></textarea>
              </td>
              <th class="col-md-2">특기사항</th>
              <td class="col-md-4">
                <textarea class="form-control field-readonly" placeholder="200자 이내" ref="txt_nContent" id="floatingTextarea" style="height:110px; font-size:smaller;" v-model="productInfo.pdtRemarks" maxlength="200" readonly></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ============ 교통정보 ============ -->
      <div class="section-card">
        <div class="section-head">
          <i class="bi bi-airplane"></i>
          <span>교통정보</span>
        </div>

        <table class="table table-bordered align-middle w-100 h-auto text-center data-table">
          <tbody>
            <tr>
              <th class="col-md-2">출발&nbsp;<i class="bi bi-arrow-right-circle"></i>&nbsp;도착</th>
              <td class="col-md-4">
                한국({{this.pdtTransInfo1.ddCodeName}}) → {{this.productInfo.ntName}}({{this.pdtTransInfo1.daCodeName}})
              </td>
              <th class="col-md-2">리턴&nbsp;<i class="bi bi-arrow-right-circle"></i>&nbsp;도착</th>
              <td class="col-md-4">
                {{this.productInfo.ntName}}({{this.pdtTransInfo1.rdCodeName}}) → 한국({{this.pdtTransInfo1.raCodeName}})
              </td>
            </tr>
            <tr>
              <th class="col-md-2">출발편</th>
              <td class="col-md-4">
                {{this.pdtTransInfo1.dmobileCodeName}}
                <small>
                  ({{this.pdtTransInfo1.dmobileCode}}{{this.pdtTransInfo1.dpTpCode}},&nbsp;{{this.pdtTransInfo1.d_dpTime}} → {{this.pdtTransInfo1.d_arTime}})
                </small>
              </td>
              <th class="col-md-2">리턴편</th>
              <td class="col-md-4">
                {{this.pdtTransInfo1.rmobileCodeName}}
                <small>
                  ({{this.pdtTransInfo1.rmobileCode}}{{this.pdtTransInfo1.rtTpcode}},&nbsp;{{this.pdtTransInfo1.r_dpTime}} → {{this.pdtTransInfo1.r_arTime}})
                </small>
              </td>
            </tr>
            <tr>
              <th class="col-md-2">추가사항</th>
              <td class="col-md-4">
                <textarea class="form-control field-readonly" placeholder="300자 이내" ref="txt_nContent" id="floatingTextarea" style="height:80px; font-size:smaller;" v-model="this.pdtTransInfo1.transRemarks_dp" maxlength="300" readonly></textarea>
              </td>
              <th class="col-md-2">추가사항</th>
              <td class="col-md-4">
                <textarea class="form-control field-readonly" placeholder="300자 이내" ref="txt_nContent" id="floatingTextarea" style="height:80px; font-size:smaller;"
                  v-model="this.pdtTransInfo1.transRemarks_ar" maxlength="300" readonly></textarea>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <div class="mb-3 row">
      <div class="col-auto d-grid p-1 mx-auto">
        <button type="button" class="btn btn-list" @click="goToList()">
          <i class="bi bi-list-ul"></i> 예약리스트
        </button>
      </div>
    </div>
  </div>
  </main>
</template>

<script>
import { handlerInfo } from '../assets/js/commonFunctions'
import { getAvailPoint } from "../assets/js/commonFunctions.js"

const PAY_DIFF_TOLERANCE = 10;   // 멤버십할인 후 10원 절사 등으로 생기는 차이 허용(10원 이하 = 일치)

export default {
  data() {
    return {
      reserveInfo: [],              //예약정보
      reservePriceInfo: [],         //예약권종정보
      selOptInfo: [],               //선택옵션정보
      dirOptInfo: [],               //직접입력옵션정보

      productCode: "",              //상품코드
      pdtFlag: "",                  //상품종류
      availPoint: 0,                //가용포인트

      rProc: [],                    //[수정] 예약진행상태 리스트(템플릿에서 rProc.find 사용 → 초기값 필요)
      cxlFlagList: [],              //취소사유리스트

      productInfo: {},              //상품정보

      paidPoint: 0,                 //사용포인트
      totPaidPoint: 0,              //[수정] 포인트결제총액(템플릿 표시용 → 반응형 선언)
      cstPrice: 0,                  //[수정] 상담가격

      pdtTransInfo1: [],            //기존교통정보
      pdtTransInfo: [],

      sRoute: [],                   //상품구분

      rtnRPflag: "N",               //결제요청여부
      userPayInfo: [],              //결제내역정보
      userPayPoint: {},             //해당예약 유저 지불포인트 정보(초기값 없으면 취소처리 시 undefined.userPoint 에러 발생)
      payPointAmt: 0,               //포인트결제액
      personCntK: 0,                //카카오알림톡용 인원수

      cxlName: "",                 //취소사유

      handTel: [],                //매니저연락처
      handTelCnt: 0,              //수신처갯수

      balance: 0,                 //부분결제 시 잔액

      /////결제히스토리용 정보
      p1PayAmt: 0, 
      p1PayDate: "",
      p2PayAmt: 0, 
      p2PayDate:"",
      payPointDate: "",
      payPointAmt2: 0,
      payPointDate2: "",
      fPayFlag: "",                //예약금결제N, 전액결제Y
      totalPay: 0,                 //히스토리합산

      payCouponAmt: 0,             //쿠폰결제액 
      payCouponDate: "",           //쿠폰결제일자
      payCouponAmt2: 0, 
      payCouponDate2:"",

      reqStatus_old: "",          //변경전 상태

      savePoint: 0,              //확정적립포인트
      savePointAmt: 0,           //[수정] 확정적립포인트액(취소 시 복구판단에 사용)
      savePointDate: "",         //확정 포인트적립일자

      // 추가상품 처리
      addPdtInfo: [],               //추가상품정보
      addPdtFlag: "N",               //추가상품기본정보

      totDiscountAmt:0,             //할인액

      selectedEtcOption: [],        //[수정] 선택된 기타옵션 (오타 selectedEtcOtion → selectedEtcOption)
      selectedEtcOptApplyDate: [],  //선택된 옵션의 적용일자(기존)

      pdtPromoInfo_apply: [],       //적용가능 프로모션(출발일기준)

      reqMarginRate: 0,             //당해예약마진
      reqMarginMethod: "P",         //당해예약마진계산방법(P/A)

      selOptPriceTot: 0,            //선택옵션총액(가격계산용)
      tot_selAddPdtPrice: 0,        //선택추상총액(가격계산용)
      personCnt: 0,                 //총인원(화면상, 가격계산용)
      payPointFlag: "N",            //포인트사용여부

      totPrice_org: 0,              //순수청구총액(일체할인 전)

      // 국가/지역/교통편 코드성 데이터
      cityList: [],
      nationList: [],
      areaList: [],
      transList: [],
      mobilityList_dp: [],          //출발편
      mobilityList_rt: [],          //리턴편
      termList_dpd: [],             //출발시작터미널
      termList_dpa: [],             //출발도착터미널
      termList_rtd: [],             //리턴시작터미널
      termList_rta: [],             //리턴도착터미널
      productPrice: {},             //상품가격
    };
  },
    // 로그인된 사용자만 접근가능페이지
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  // 생성 시, 상품카테고리 가져온다
  created() {
    this.reqRsvCode = this.$route.query.seqReq;
    this.productId = this.$route.query.pCode;
    this.copyFlag = this.$route.query.cCode;

    this.salesRoute = this.$route.query.salesRoute;
    this.ntCd = this.$route.query.ntCd;

    this.getReqProcLevel();
    this.getReserInfo_new()

    this.getProductInfo();
    this.getSalesRoute();

    this.getProductTransInfoExited(); //기존교통정보
    this.getProductTransInfo();
    this.getProductPrice();

    this.getCityList();
    this.getNationList();
    this.getTransList();

    this.getHandlerInfo()           //알림톡 발송대상 체크
  },
  mounted() {
    // 로그인한 사람이 아니라면 메인화면으로
    if(this.user.handlerGrade > 9 || this.user.handlerGrade == undefined) {
      var swal = require('sweetalert2');
      swal.fire({
        title: '',
        text: '로그인 권한이 없습니다.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }

    document.getElementById("user").style.display = "none";
  },
  methods: {
    /** 윈도우즈 계산기호출*/
    callWinCalc() 
    { 
      window.open('Calculator: ');
    },
    //상태변화체크
    async changeProcCode(rProcCode)
    {
      if(rProcCode === "CX")
      {
        this.$swal.fire("","취소사유를 반드시 선택해주세요!", "question")
        return false;
      }
      this.reserveInfo.reqStatus = (rProcCode == '') ? this.reserveInfo.reqStatus : rProcCode

      //예약확인상태로 변경
      if(this.reserveInfo.rCopyFlag == 'N' && this.reqStatus_old !== rProcCode)
      {
        let updResConfirm = await this.$api("/api/updResConfirm", {param: [this.user.handlerId, this.reqRsvCode]});
        if(updResConfirm.affectedRows < 0 || updResConfirm.affectedRows == undefined)
        {
          this.$swal.fire("","예약확인상태 변경 중에 에러가 발생했습니다. 다시 진행해주세요", "warning")
          return false
        }
        else
        {
          this.$swal.fire("","당해 예약은 확인이 되었습니다", "info")
        }
      }
    },

    //취소사유추적
    async changeCxlCode(cxCode)
    {
      // 사유입력 시 확인처리
      await this.$api("/api/updResConfirm", {param: [this.user.handlerId, this.reqRsvCode]});
      
      let cxlName_tmp = this.cxlFlagList.filter((item) => {
        return item.procCode === cxCode
      })

      let cxlName = cxlName_tmp[0].procName
      this.reserveInfo.cxlFlag = (cxCode == '') ? this.reserveInfo.cxlFlag : cxCode
      this.cxlName = (cxCode == '') ? this.reserveInfo.cxlReason : cxlName
    },    

    // 추가상품 구매여부
    async getAddPdtInfo() {
      let addPdtInfo = await this.$api("/api/addPdtInfo", {param: [this.reqRsvCode]});

      if(addPdtInfo.length > 0)
      {
        this.addPdtFlag = "Y"           //추가상품여부
        this.addPdtInfo = addPdtInfo;
        this.getTotalPrice();
      }
      else
      {
        // 결제금액계산
        this.getTotalPrice();
      }
    },

    // 선택형옵션 (NEW 예약용) 획득
    async getSelOptInfo() {
      let selOptInfo = await this.$api("/api/selOptInfo", {param: [this.reqRsvCode]});

      if(selOptInfo.length > 0)
      {
        this.selOptFlag = "Y"           //선택옵션유무
        this.selOptInfo = selOptInfo;
        this.getTotalPrice();
      }
      else
      {
        // 결제금액계산
        this.getTotalPrice();
      }
    },

    // 직접형옵션 획득 (NEW 예약용)
    async getDirOptInfo() {
      let dirOptInfo = await this.$api("/api/dirOptInfo", {param: [this.reqRsvCode]});

      if(dirOptInfo.length > 0)
      {
        this.dirOptFlag = "Y"           //직접옵션유무
        this.dirOptInfo = dirOptInfo;
      }
    },

    //결제총액추출 (NEW 예약용)
    getTotalPrice() {
      let totalPrice = 0
      // 선택옵션의 총액
      if(this.selOptInfo.length > 0) {
        totalPrice = this.selOptInfo.reduce((sum, item) => sum + (item.optPrice * (item.qty_opt ?? 0)), 0);
      }

      this.pdtTotalPrice = totalPrice
    },    

    // new res type
    async getReserInfo_new()
    {
      let reserveInfo = await this.$api("/api/resConsultDetail_new", {param: [this.reqRsvCode]});

      if(reserveInfo.length > 0) 
      {
        this.reserveInfo = reserveInfo[0]
        this.tot_perCount = reserveInfo[0].totalCount                                            //New가격에서는 상품구매수 = 인원수
        this.productCode = reserveInfo[0].reqPdtCode;
        //출발예정일-리턴예정일
        this.reserveInfo.reqDptDate = this.getDateFormat(reserveInfo[0].reqDptDate);
        this.reserveInfo.reqRtnDate = this.getDateFormat(reserveInfo[0].reqRtnDate);
        this.reserveInfo.reqDate = this.getDateFormat(reserveInfo[0].reqDate);                   //insDate 예약일
        this.cstPrice = reserveInfo[0].totalPrice*1;                                             //상담가격
        this.addPdtFlag = reserveInfo[0].addPdtFlag

        this.totPrice_org = this.reserveInfo.totalPrice*1                                        //대금총액(할인전)
        this.reqStatus_old = this.reserveInfo.reqStatus                                          //[수정] 변경전 상태 보관(상태변경 감지용)
      }

      let reserveInfo_detail = await this.$api("/api/reservePriceInfo_new", {param: [this.reqRsvCode]});
        if(reserveInfo_detail.length > 0)
        {
          this.reserveInfo_detail = reserveInfo_detail
        }

      //가용포인트 체크
      this.getAvailPoint();

      // 선택형 옵션정보
      this.getSelOptInfo();
      // 직접형 옵션정보
      this.getDirOptInfo();

      // 추가상품정보
      this.getAddPdtInfo()

      //[수정] 결제요청 여부 — 이 호출이 빠지면 결제내역/잔여대금/히스토리가 전혀 표시되지 않음
      this.getReqPayInfo(this.reqRsvCode);

      //당해예약 지불/적립포인트
      this.getUserPayPoint(this.reqRsvCode)
    },

    /** null/undefined(옵션: 음수 포함)를 0으로 치환. 그 외엔 원값 그대로 반환 */
    orZero(val, clampNegative = false)
    {
      if(val == null || (clampNegative && val < 0)) return 0
      return val
    },
    /** null/undefined면 빈 문자열, 아니면 한국형식 날짜문자열로 변환 */
    orEmptyKorDate(val)
    {
      return (val == null) ? "" : this.getKorDateFormat(val)
    },

    //분할결제(1차/2차)인 경우 "-1" 접미사가 붙은 예약코드로 조회
    buildPartialPayResCode(val)
    {
      let isPartialPay = (this.reserveInfo.partFlag === "1" || this.reserveInfo.partFlag === "2")
      return isPartialPay ? val+"-1" : val
    },

    //결제요청내역 조회 (가상계좌 WP상태는 별도 API 사용)
    async fetchReqPayInfo(resCode)
    {
      if(this.reserveInfo.reqStatus === "WP")
      {
        return await this.$api("/api/getReqPayInfo_vir", {param: [resCode]});
      }
      return await this.$api("/api/getReqPayInfo", {param: [resCode]});
    },

    //결제유형(payFlag)별 잔액/총액 검증 및 반영. 상품대금과 실결제액이 맞지 않으면 false 반환
    validatePayAmount(payInfo)
    {
      const memDC      = Number(this.orZero(this.reserveInfo.memDCAmt))
      const grossPrice = Number(this.orZero(this.reserveInfo.totalPrice))     // 할인 전 대금 (원본은 건드리지 않음)
      const netPrice   = grossPrice - memDC                                   // 멤버십할인 후 청구대상액

      const actualPay  = Number(this.orZero(payInfo.actualPayAmount))
      const pointAmt   = Number(this.orZero(payInfo.payPointAmt, true))
      const couponAmt  = Number(this.orZero(payInfo.payCouponAmt, true))
      const couponAmt2 = Number(this.orZero(payInfo.payCouponAmt2, true))

      if(payInfo.payFlag === 'p1')        //부분결제 → 잔여대금
      {
        payInfo.payPointAmt  = pointAmt
        payInfo.payCouponAmt = couponAmt

        const balance = netPrice - actualPay - pointAmt - couponAmt
        this.balance = (balance <= PAY_DIFF_TOLERANCE) ? 0 : balance         // 절사오차 수준이면 잔여대금 없음
      }
      else if(payInfo.payFlag === 'p2' || payInfo.payFlag === 'fu')   //전액 또는 잔액결제
      {
        //가상계좌(WP)는 입금 전 후불형식이므로 검증 제외
        if(this.reserveInfo.reqStatus === "WP") return true

        const paidTotal = actualPay + Number(this.orZero(this.totPaidPoint)) + couponAmt + couponAmt2
        const diff = Math.abs(netPrice - paidTotal)

        if(diff > PAY_DIFF_TOLERANCE)
        {
          console.warn("[결제불일치]", { resCode: this.reqRsvCode, netPrice, paidTotal, diff, payInfo })
          this.$swal.fire("","최종결제금액과 상품대금이 일치하지 않습니다. 실제결제된 금액을 확인해주세요", "warning")
          return false
        }
      }
      return true
    },

    //결제내역 화면표시용 필드 정리(금액/일자, this.userPayInfo 기준)
    applyPaymentDisplayFields()
    {
      let info = this.userPayInfo

      this.p1PayAmt       = this.orZero(info.p1PayAmt)
      this.p2PayAmt       = this.orZero(info.p2PayAmt)
      this.p1PayDate      = this.orEmptyKorDate(info.p1PayDate)
      this.p2PayDate      = this.orEmptyKorDate(info.p2PayDate)
      this.payPointAmt    = this.orZero(info.payPointAmt)
      this.payPointDate   = this.orEmptyKorDate(info.payPointDate)
      this.payPointAmt2   = this.orZero(info.payPointAmt2)
      this.payPointDate2  = this.orEmptyKorDate(info.payPointDate2)
      this.payCouponAmt   = this.orZero(info.payCouponAmt)
      this.payCouponDate  = this.orEmptyKorDate(info.payCouponDate)
      this.payCouponAmt2  = this.orZero(info.payCouponAmt2)
      this.payCouponDate2 = this.orEmptyKorDate(info.payCouponDate2)

      this.totalPay = this.p1PayAmt*1 + this.p2PayAmt*1 + this.payPointAmt*1 + this.payPointAmt2*1
                    + this.payCouponAmt*1 + this.payCouponAmt2*1 + Number(this.orZero(this.reserveInfo.memDCAmt))

      //전액(Y) / 부분(N) 결제여부 — 10원 이하 차이는 전액결제로 간주
      let diff = Math.abs(this.totPrice_org - this.totalPay)
      this.fPayFlag = (diff > PAY_DIFF_TOLERANCE) ? "N" : "Y"
    },

    // 불일치여도 결제내역은 보여지도록 수정
    async getReqPayInfo(val)
    {
      let payPointInfo = await this.$api("/api/sum_paidPoint", {param: [val]});
      this.totPaidPoint = this.orZero(payPointInfo[0]?.totPaidPoint)

      let resCode = this.buildPartialPayResCode(val)
      let payInfoList = await this.fetchReqPayInfo(resCode)

      if(payInfoList.length > 0)
      {
        this.rtnRPflag = "Y"
        let payInfo = payInfoList[0]

        this.validatePayAmount(payInfo)     // 불일치면 경고만 띄우고
        this.userPayInfo = payInfo          // 내역은 그대로 보여줌(담당자가 확인할 수 있도록)
      }
      else
      {
        this.rtnRPflag = "N"
      }

      this.applyPaymentDisplayFields()
    },

    //예약확정->포인트적립
    pSetAside()
    {
      let setAsidePoint = 0;

      if(this.reserveInfo.rePointMethod === 'P')
      {
        //rePoint는 멤버십 추가적립여부 반영된 수치
        setAsidePoint = (this.userPayInfo.actualPayAmount*1) * ((this.reserveInfo.rePoint*1) / 100)     //실제지불금액 기준으로 포인트적립
      }
      else
      {
        setAsidePoint = this.reserveInfo.rePoint*1
      }
      
      this.$swal.fire({
      icon: 'question',
      html: setAsidePoint + '포인트를 적립하시겠습니까?<br>※ 고객이 결제한 금액에 대해서만 포인트가 적립됩니다(쿠폰,포인트 제외).',
      showCancelButton: true,
      confirmButtonText: '적립',
      cancelButtonText: '나중에'
      }).then(async (result) => 
      {
        if (result.isConfirmed) 
        {
          let pSetAside = await this.$api("/api/payByPoint", {param: [
            this.reserveInfo.reqEmail,setAsidePoint,'A',this.reqRsvCode, '확정적립'
            ]});
            if(Object.keys(pSetAside)[0] === 'error') 
            {
              this.$swal.fire('', '포인트적립 중 오류가 발생하였습니다립(코드: pSetAside).<br>관리자에게 문의해 주세요.', 'error');
              return false;
            }
            else
            {
              this.$swal.fire('', setAsidePoint+'포인트 적립되었습니다.', 'success');              
            }
        }
      })
    },

    async getReqProcLevel() {
      //예약진행상태
      let rProc = await this.$api("/api/reqProcLevel", {});
      if(rProc.length > 0) {
        this.rProc = rProc
      }

      //취소사유
      let cxlFlagList = await this.$api("/api/reqStatusInfo2", {param: ['CXL', 'Y']});
      if(cxlFlagList.length > 0) {
        this.cxlFlagList = cxlFlagList
      }
    },

    // 잔액결제청구
    async payBalance(){
      let reqPayBalanceStat = await this.$api("/api/reqPayBalanceStat", {param: [
        "Y", this.balance, this.reqRsvCode+"-1"
      ]});
      
      if(reqPayBalanceStat.affectedRows < 0)
      {
        this.$swal.fire("","잔액결제청구에 문제가 발생했습니다. 재시도 또는 관리자에게 문의해주세요", "warning")
        return false
      }
      else
      {
        this.sendKakao("RP", this.reserveInfo.resMFlag, "p2")
      }
    },

    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0)
      {
        this.handTel = handTel
      }
    },

    /** 카카오알림 발송 */
    async sendKakao(param, mFlag, pFlag)   //예약상태, 회원여부
    {
      if(mFlag === 'N')
      {
        param = "non" + param
      }

      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        this.reqRsvCode, param, this.user.handlerId
      ]});

      //알림톡 발송대상 확정
      this.handTel.push({aimCall: this.reserveInfo.reqTelNo})
      this.handTelCnt = this.handTel.length

      if(insKSendHistory.affectedRows > 0) 
      {
        let today = new Date();
        let yyyy = today.getFullYear();
        let mm_tmp = today.getMonth()+1;
        let dd_tmp = today.getDate();
        
        let mm = "";
        if(mm_tmp < 10) {mm = "0" + mm_tmp}
        else mm = mm_tmp;
        let dd = "";
        if(dd_tmp < 10) {dd = "0" + dd_tmp}
        else dd = dd_tmp;

        let curDate = yyyy + "-" + mm + "-" + dd

        //부분결제의 잔액청구 시, 처리
        let resPayAmount = 0
        if(pFlag === "p2")
        {
          resPayAmount = this.balance
        }
        else
        {
          resPayAmount = this.cstPrice
        }

        let promises = []         //promise들의 배열
        if(param == "RP") 
        {
          let i = 0
          while(i < this.handTelCnt)
          {
            //결제요청 카카오 알림톡
            let kakaoAlimData = 
            {
              //카카오 알림톡 발송(결제요청)
              clientName: this.reserveInfo.reqName,
              resName: this.productInfo.pdtNameKor,
              resPaxName: this.reserveInfo.reqName,
              resPaxCnt: this.personCntK,
              dptDate: this.reserveInfo.reqDptDate,
              resPhone: this.reserveInfo.reqTelNo,
              resCode: this.reqRsvCode,
              resPayAmount: this.getCurrencyFormat(resPayAmount),
              resManager: this.productInfo.handlerNameKor,
              alimFlag: param,                                         //알림유형(결제요청)
              pdtCode: this.productInfo.pdtCode,                       //결제처리용 상품코드
              clientCall: this.handTel[i].aimCall,                       //알림톡발송대상
            };
            let promise = this.$api("api/kakaoAlimSend2", {
              param: [{ kakaoAlimData: kakaoAlimData}]
            })

            promises.push(promise)
            i++
          }

          //반복문 이후 처리
          Promise.all(promises).then((results) => {
            console.log(results)
            this.$swal.fire('', '결제요청 알림톡이 발송되었습니다', 'success').then(() => {
              location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })
        }

        else if(param == "nonRP") 
        {
          let j = 0
          while(j < this.handTelCnt)
          {
            //비회원용 결제요청 카카오 알림톡
            let kakaoAlimData = 
            {
              //카카오 알림톡 발송(결제요청)
              clientName: this.reserveInfo.reqName,
              resName: this.productInfo.pdtNameKor,
              resPaxName: this.reserveInfo.reqName,
              resPaxCnt: this.personCntK,
              dptDate: this.reserveInfo.reqDptDate,
              resPhone: this.reserveInfo.reqTelNo,
              resCode: this.reqRsvCode,
              resPayAmount: this.getCurrencyFormat(resPayAmount),
              resManager: this.productInfo.handlerNameKor,
              alimFlag: param,                                        //알림유형(결제요청)
              pdtCode: this.productInfo.pdtCode,                      //비회원예약 결제처리용 상품코드
              clientCall: this.handTel[j].aimCall,                      //알림톡발송대상
            };
            let promise = this.$api("api/kakaoAlimSend2", {
              param: [{ kakaoAlimData: kakaoAlimData}]
            })

            promises.push(promise)

            j++
          }

          //반복문 이후 처리
          Promise.all(promises).then((results) => {
            console.log(results)
            this.$swal.fire('', '결제요청 알림톡이 발송되었습니다', 'success').then(() => {
              location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })
        }


        else if(param == "CO" || param == "nonCO") 
        {
          let i = 0
          while(i < this.handTelCnt)
          {
            //카카오 알림톡 발송(확정)
            let kakaoAlimData = 
            {
              clientName: this.reserveInfo.reqName,
              resCode: this.reqRsvCode,
              resName: this.productInfo.pdtNameKor,
              resPrice: this.getCurrencyFormat(this.cstPrice),
              alimCall: this.reserveInfo.reqTelNo,
              alimFlag: param,
              pdtCode: this.productInfo.pdtCode,                     //비회원예약 결제처리용 상품코드
              clientCall: this.handTel[i].aimCall,                    //알림톡발송대상
            };

            let promise = this.$api("api/kakaoAlimSend", {
              param: [{ kakaoAlimData: kakaoAlimData}]
            })

            promises.push(promise)

            i++
          }
          Promise.all(promises).then((results) => {
            console.log(results)
            this.$swal.fire('', '예약확정 알림톡이 발송되었습니다', 'success').then(() => {
              location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })
        }

        //취소처리
        else if(param == "CX" || param == "nonCX") 
        {
          let i = 0
          while(i < this.handTelCnt)
          {
            //카카오 알림톡 발송(취소)
            let kakaoAlimData = 
            {
              clientName: this.reserveInfo.reqName,
              resCode: this.reqRsvCode,
              resDate: this.getDateFormat(this.reserveInfo.insDate),
              dptDate: this.reserveInfo.reqDptDate,
              cxlDate: curDate,
              cxlRemark: this.cxlName,                      //취소사유 
              alimCall: this.reserveInfo.reqTelNo,
              clientCall: this.handTel[i].aimCall,                        //카톡발송연락처
              pdtCode: this.productInfo.pdtCode,                          //비회원예약 결제처리용 상품코드            
              alimFlag: param,
            };

            let promise = this.$api("api/kakaoAlimSend2", {
              param: [{ kakaoAlimData: kakaoAlimData}]
            })

            promises.push(promise)

            i++
          }

          Promise.all(promises).then((results) => {
            console.log(results)
            this.$swal.fire('', '예약취소 알림톡이 발송되었습니다', 'success').then(() => {
              location.reload(true)
            })
          }).catch((error) => {
            console.log("Error calling api: ", error)
          })

        }
      }
    },

    //해당예약의 유저가 사용한 포인트
    async getUserPayPoint(resCode)
    {
      let userPayPoint = [];
      userPayPoint = await this.$api("/api/getUserPayPoint", {param: [this.reserveInfo.reqEmail, resCode]});
      if(userPayPoint.length > 0)
      {
        this.userPayPoint = userPayPoint[0];
      }

      //포인트적립내역(확정)
      let savePointInfo = await this.$api("/api/savePoint_new", {param: [resCode]});
      //확정적립 포인트정보
      if(savePointInfo.length > 0)
      {
        if(savePointInfo[0].userPoint > 0 && savePointInfo[0].useFlag === 'A')
        {
          //포인트결제내역
          this.savePointAmt = savePointInfo[0].userPoint
          this.savePointDate = savePointInfo[0].pointAddDate
        }
        else
        {
          this.savePointAmt = 0
        }
      }
    },

    //공통함수사용(commonFunctions.js)
    async getAvailPoint() 
    {
      this.availPoint = await getAvailPoint(this.$api, this.reserveInfo.conEmail)
    },

  /////////////상담가격계산(터미널이용료/유류할증료 별도표시)
    /** 여정기간 중 상품가격합산식 */
    calcCstPrice() 
    {
      let aduPrice = 0;
      let chiPrice = 0;
      let infPrice = 0;
      let disPrice = 0;
      let pdtPrice = 0;

      //여행참가인원수
      let personCnt = (this.reserveInfo.reqAdultCnt*1 + this.reserveInfo.reqChildCnt*1 + this.reserveInfo.reqInfCnt*1 + this.reserveInfo.reqDiscountCnt*1);
      this.personCnt = personCnt*1;

      //1권종가격기준
      if(this.reserveInfo.reqTripProp == "D")
      {
        aduPrice = (this.reserveInfo.reqAdultPrice*1) * (this.reserveInfo.reqAdultCnt*1);
        chiPrice = (this.reserveInfo.reqChildPrice*1) * (this.reserveInfo.reqChildCnt*1);
        infPrice = (this.reserveInfo.reqInfPrice*1) * (this.reserveInfo.reqInfCnt*1);
        disPrice = 0
        pdtPrice = (aduPrice*1) + (chiPrice*1) + (infPrice*1) + (disPrice*1);
      }
      else //F속성의 daily price를 배열로 취득
      {
        let fAduPrice = document.getElementsByName("fAduPrice[]");
        let fChiPrice = document.getElementsByName("fChiPrice[]");
        let fInfPrice = document.getElementsByName("fInfPrice[]");
        let fDisPrice = 0

        let i = 0;
        while(i<fAduPrice.length)
        {
          aduPrice += (fAduPrice[i].value)*1;
          chiPrice += (fChiPrice[i].value)*1;
          infPrice += (fInfPrice[i].value)*1;
          disPrice = fDisPrice + 0
          i++;
        }
        pdtPrice = aduPrice*1 + chiPrice*1 + infPrice*1 + disPrice*1;
      }

      //2.마진적용
      let pdtPriceMargin = 0;
      if(this.reqMarginMethod ==="A")
      {
        pdtPriceMargin = this.reqMarginRate*1
      }
      else
      {
        if(this.reqMarginRate*1 > 0)
        {
          pdtPriceMargin = (pdtPrice*1) * ((this.reqMarginRate*1)/100);
        }
        else
        {
          pdtPriceMargin = 0;
        }
      }
      this.reserveInfo.pdtMargin = pdtPriceMargin*1;
      pdtPrice = pdtPrice*1 + pdtPriceMargin*1;

      //멤버십할인 적용
      if(this.totDiscountAmt > 0)
      {
        pdtPrice = pdtPrice - this.totDiscountAmt*1
      }

      //동반할인 적용
      if(this.reserveInfo.tot_comDC > 0)
      {
        pdtPrice = pdtPrice - (this.reserveInfo.tot_comDC*1)
      }
      
      //3.프로모션 적용
      let promoRateApply = this.pdtPromoInfo_apply.promoRate * 1;
      let promoMethodApply = this.pdtPromoInfo_apply.promoMethod;
      let pdtPromo = 0;
      if(promoMethodApply === "A") {
        pdtPromo = promoRateApply*1;
      }
      else if(promoMethodApply === "P") {
        pdtPromo = (pdtPrice*1) * ((promoRateApply*1)/100);
      }
      else {
        pdtPromo = 0;
      }
      this.reserveInfo.pdtPromo = pdtPromo*1;
      pdtPrice = pdtPrice*1 - pdtPromo*1;


      //4.선택된 기타옵션 적용
      let ac = this.reserveInfo.reqAdultCnt    //권종별인원수
      let cc = this.reserveInfo.reqChildCnt
      let ic = this.reserveInfo.reqInfCnt
      let dc = 0

      //옵션별 적용일자 카운트정보
      let obj_selectedEtcOptApply = {}

      this.selectedEtcOptApplyDate.forEach(item => {
        let etcOptCode = item.etcOptCode

        if(!obj_selectedEtcOptApply[etcOptCode])
        {
          obj_selectedEtcOptApply[etcOptCode] = [];
        }
        obj_selectedEtcOptApply[etcOptCode].push(item)
      });

      //배열로 반환
      let selectedEtcOptApply = Object.values(obj_selectedEtcOptApply)

      let j = 0
      let selectedEtcOptApplyCount = []       //선택옵션별 적용일자 카운트배열
      while(j < selectedEtcOptApply.length)
      {
        selectedEtcOptApplyCount.push([selectedEtcOptApply[j][0].etcOptCode, selectedEtcOptApply[j].length])
        j++
      }

      let i = 0
      let tot_etcOptCode = 0
      let tot_etcOptCodePrice = 0
      while(i < this.selectedEtcOption.length)
      {
        let eCode = this.selectedEtcOption[i].etcOptCode

        let matchingOptCode = selectedEtcOptApplyCount.find(item => item[0] === eCode)
        
        if(matchingOptCode)
        {
          tot_etcOptCode = (this.selectedEtcOption[i].eAduPrice*ac + this.selectedEtcOption[i].eChiPrice*cc + this.selectedEtcOption[i].eInfPrice*ic + dc) * matchingOptCode[1]
        }

        tot_etcOptCodePrice += tot_etcOptCode

        i++
      }

      //특별할인 처리
      pdtPrice = (pdtPrice*1) + (tot_etcOptCodePrice*1) - (this.reserveInfo.optDcPrice*1)

      //5.payPoint처리
      if(this.reserveInfo.payPoint > 0)
      {
        this.payPointFlag = "Y";
        pdtPrice = pdtPrice*1 - (this.reserveInfo.payPoint*1);
      }


      //6.부가세 적용
      let vatR = 0;
      if(this.reserveInfo.reqVatPrice > 0) 
      {
        vatR = (pdtPrice*1) * ((this.reserveInfo.reqVatPrice*1)/100);
      }
      else
      {
        vatR = 0;
      }
      this.reserveInfo.vatPrice = vatR;
      pdtPrice = pdtPrice*1 + vatR*1;
      
      
      //7.소숫점아래 절사처리
      pdtPrice = Math.floor(pdtPrice);

      this.cstPrice = pdtPrice*1  + this.selOptPriceTot + this.tot_selAddPdtPrice
    },
    async getProductInfo() 
    {
      this.pdtFlag = (this.productId.substring(0,2) === 'MX') ? "MX" : "SG"
      let productInfo = {};
      if(this.pdtFlag === "SG") 
      {
        productInfo = await this.$api("/api/pdtInfo", {param: [this.productId]});
      }
      else if(this.pdtFlag === "MX") 
      {
        productInfo = await this.$api("/api/pdtInfo_mix", {param: [this.productId]});
      }
      else 
      {
        return this.$swal.fire("","상품이 검색되지 않습니다<br>재확인 후 시도해 주세요.","error");
      }
      this.productInfo = productInfo[0]
      this.productInfo.tripStart = this.getDateFormat(this.productInfo.tripStart);
      this.productInfo.tripEnd = this.getDateFormat(this.productInfo.tripEnd);
      this.productInfo.salesStart = this.getDateFormat(this.productInfo.salesStart);
      this.productInfo.salesEnd = this.getDateFormat(this.productInfo.salesEnd);
    },

    async getSalesRoute() {
      this.sRoute = await this.$api("/api/salesRoute", {});
    },

    //기존상품 교통정보
    async getProductTransInfoExited() {
      let pdtTransInfo1 = await this.$api("/api/pdtTransInfo_existed", {param: [this.productId]});
      if(pdtTransInfo1.length > 0) {
        this.pdtTransInfo1 = pdtTransInfo1[0];
      }
    },
    async getProductTransInfo() {
      let pdtTransInfo = await this.$api("/api/pdtTransInfo", {param: [this.productId]});
      //[수정] this.pdtTransInfo(항상 빈 배열) → 조회결과 로컬변수로 검사
      if(pdtTransInfo.length > 0){
        this.pdtTransInfo = pdtTransInfo[0];
      }
      this.pageOpen();
    },

    async getCityList() {
      let cityList = await this.$api("/api/cityList", {});
      if(cityList.length > 0) {
        this.cityList = cityList;
      }
    },    
    async getNationList() {
      let nationList = await this.$api("/api/nationList", {});
      this.nationList = nationList;
    },
    //넘어온 파라메타로 교통편표시
    async pageOpen(){
      this.getAreaList_pageOpen()
      if(this.salesRoute === "T" || this.salesRoute === "L") {
        this.viewDpMobilityList_pageOpen();
        this.viewRtMobilityList_pageOpen();
        this.getDpTermList_pageOpen();
        this.getRtTermList_pageOpen();
      }
    },
    //페이지 오픈시 교통정보 호출
    async getAreaList_pageOpen() {
      let areaList1 = await this.$api("/api/areaList", {});
      this.areaList = areaList1.filter(e => {return e.categoryCode === this.ntCd});
    },
    async viewDpMobilityList_pageOpen(){
      let mobilityList_tmp1 = await this.$api("/api/mobilityList", {});
      this.mobilityList_dp = mobilityList_tmp1.filter(e => {return e.categoryCode === this.pdtTransInfo.trCd1});
    },
    async viewRtMobilityList_pageOpen(){
      let mobilityList_tmp1 = await this.$api("/api/mobilityList", {});
      this.mobilityList_rt = mobilityList_tmp1.filter(e => {return e.categoryCode === this.pdtTransInfo.trCd2});
    },
    async getDpTermList_pageOpen() {
      let param4 = "";
      if(this.pdtTransInfo.trCd1 === "SHP") {
        param4 = "ptCd";
      }
      else if(this.pdtTransInfo.trCd1 === "FLT") {
        param4 = "apCd";
      }
      else {
        param4 = "";
      }
      if(param4 === "ptCd" || param4 === "apCd") {
        this.termList_dpd = await this.$api("/api/termList", {param: ["KR", param4]});
        //출발도착터미널
        this.termList_dpa = await this.$api("/api/termList1", {param: ["KR", this.ntCd, param4]});
      }
      else{
        this.termList_dpd = "";
        this.termList_dpa = "";
      }
    },
    async getRtTermList_pageOpen() {
      let param5 = "";
      if(this.pdtTransInfo.trCd2 === "SHP") {
        param5 = "ptCd";
      }
      else if(this.pdtTransInfo.trCd2 === "FLT") {
        param5 = "apCd";
      }
      else {
        param5 = "";
      }
      if(param5 === "ptCd" || param5 === "apCd") {
        this.termList_rtd = await this.$api("/api/termList", {param: [this.ntCd, param5]});
        this.termList_rta = await this.$api("/api/termList1", {param: ["KR", this.ntCd, param5]});
      }
    },
    //교통수단, 교통편 정보
    async getTransList() {
      let transList = await this.$api("/api/transList", {});
      this.transList = transList;
    },
    //상품가격
    async getProductPrice() {
      //[수정] 선언된 적 없는 this.pdtCode(undefined) → 라우트로 받은 상품코드
      let productPrice = await this.$api("/api/productPrice", {param: [this.productId]});
      this.productPrice = productPrice;
    },

    goToList() {
      this.$router.push({path: '/reserveInfoList_admin'});
    },

    //취소 카운팅(전체상품)
    async countPageView_cxl(sRoute, pCode){
      let countPageView_cxl = await this.$api("/api/proc_pdtCountPageView_cxl", {param:[ sRoute, pCode ]})
      if(countPageView_cxl.affectedRows > 0) 
      {
        console.log("clx Done!")
      }
    },

    //취소카운팅(연계상품)
    async countPageView_asso_cxl(pCode, assoCode){
      let countPageView_cxl_asso = await this.$api("/api/proc_countPageView_cxl", {param:[ pCode, assoCode ]})
      if(countPageView_cxl_asso.affectedRows > 0) 
      {
        console.log("clx Done!")
      }
    },

    /** 현재시각을 yyyy-mm-dd hh:mm:ss 형식 문자열로 반환 */
    getNowDateTime() {
      let today = new Date();
      let yyyy = today.getFullYear();
      let mm = String(today.getMonth()+1).padStart(2, "0");
      let dd = String(today.getDate()).padStart(2, "0");
      let hour = today.getHours();
      let min = today.getMinutes();
      let sec = today.getSeconds();
      return `${yyyy}-${mm}-${dd} ${hour}:${min}:${sec}`;
    },

    dataBaseTransaction(p1,p2){ 
      if(p1 === "U" && p2 ==="R") 
      {
        let changedFlag = ""      //담당자 확인플래그
        //예약상태가 변경되면 접수에서 신규에서 뺀다
        if(this.reqStatus_old != this.reserveInfo.reqStatus)
        {
          changedFlag = "Y"
        }

        //취소 + (지불포인트 || 적립포인트 || 쿠폰사용액이 있는 경우)
        if(this.reserveInfo.reqStatus === "CX" && ((this.userPayPoint.userPoint > 0 || this.savePointAmt > 0) || (this.payCouponAmt > 0 || this.payCouponAmt2 > 0)))
        {
          if(this.reserveInfo.cxlFlag == null || this.reserveInfo.cxlFlag == '')
          {
            this.$swal.fire("","취소사유를 선택하세요!","error")
            return false;
          }

          this.$swal.fire({
            icon: 'question',
            text: '결제에 사용된 포인트나 쿠폰이 있으면 복구처리를 합니다.',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
          }).then(async (result) => 
          {
            if (result.isConfirmed) 
            {
              // 구매통계에 취소반영
              if(this.userPayInfo.payFlag === "fu" || this.userPayInfo.payFlag === "p2" || this.userPayInfo.payFlag == undefined)
              {
                //일반구매카운트
                this.countPageView_cxl(this.productInfo.salesRoute, this.productId)
                //연계플래그가 있으면 카운트
                if(this.productInfo.assoFlag != undefined && this.productInfo.assoFlag != "" && this.productInfo.assoFlag != null)
                {
                  //연계구매카운트
                  this.countPageView_asso_cxl(this.productId, this.productInfo.assoFlag)
                }
              }

              let payByPoint = []
              let recoverCoupon = []
              
              //지불 또는 적립포인트가 있는 경우
              if(this.userPayPoint.userPoint > 0 || this.savePointAmt > 0)
              {
                payByPoint = await this.$api("/api/updPointRecovery", {param: [ this.reserveInfo.reqEmail ,this.reqRsvCode ]});

                if(payByPoint.affectedRows < 0) 
                {
                  this.$swal.fire('', '포인트 복구처리 중 오류가 발생하였습니다.<br>관리자에게 문의해 주세요.', 'error');
                  return false;
                }
              }

              //쿠폰사용액이 있는 경우
              if(this.payCouponAmt > 0 || this.payCouponAmt2 > 0)
              {
                recoverCoupon = await this.$api("/api/updCouponRecovery", {param: [ this.reqRsvCode ]});
                if(recoverCoupon.affectedRows < 0) 
                {
                  this.$swal.fire('', '사용쿠폰 복구처리 중 오류가 발생하였습니다.<br>관리자에게 문의해 주세요.', 'error');
                  return false;
                }
              }
              if(this.rtnRPflag === "Y")
              {
                this.updReqPay();
              }
              else
              {
                this.insReqPay();
              }

              let insDate = this.getNowDateTime();
              let oldComment = this.reserveInfo.oldComment;
              let newComment = this.reserveInfo.newComment;
              let insComment = oldComment +'\n'+ "["+ this.user.handlerId +":"+ insDate +"]: "+ newComment;
              let checkReqCxl = await this.$api("/api/checkReqCxl", {param: [this.reqRsvCode]});
              
              let cxl_reserve_m = await this.$api("/api/cxl_reserve_m", {param: [
                this.reserveInfo.reqStatus,this.user.handlerId,insComment,this.reserveInfo.cxlFlag,
                this.reqRsvCode
              ]});
              
              if(cxl_reserve_m.affectedRows < 0 || cxl_reserve_m.affectedRows === undefined)
              {
                this.$swal.fire('', '예약취소 중 중 오류가 발생하였습니다.', 'error');
                return false;
              }
              else
              {
                if(checkReqCxl.length > 0)
                {
                  let upd_reqCxl = await this.$api("/api/upd_reqCxl", {param: [
                    this.user.handlerId,'Y',this.reqRsvCode
                  ]});
                  if(upd_reqCxl.affectedRows < 0 || upd_reqCxl.affectedRows === undefined)
                  {
                    this.$swal.fire('', '예약취소 중 중 오류가 발생하였습니다.', 'error');
                    return false;
                  }
                }
                // 취소에 따라 재고복구 + 추가상품도 반영
                await this.update_selOptQty(this.reqRsvCode)

                //취소팝업 후, 알림톡 발송
                this.$swal.fire('', '예약이 취소되었습니다.', 'success').then(() => {
                  this.sendKakao(this.reserveInfo.reqStatus, this.reserveInfo.resMFlag)
                })
              }
            }
          })
        }
        else
        {
          if(this.reserveInfo.reqStatus === "CX" && (this.reserveInfo.cxlFlag == null || this.reserveInfo.cxlFlag == ''))
          {
            this.$swal.fire("","취소사유를 선택하세요!","error")
            return false;
          }

          if(this.cstPrice =="0" && this.reserveInfo.totalPrice != this.reserveInfo.payPoint)   //전액포인트 결제가 아닌데 0원인 경우발생 시 대응
          {
            this.$swal.fire("","상품가격 재계산을 하십시오,","warning");
            return false;
          }

          //결제요청 또는 예약취소의 경우, 결제요청상태 체크
          if(this.reserveInfo.reqStatus === "RP" || this.reserveInfo.reqStatus === "CO")
          {
            if(this.rtnRPflag === "Y")        // 결제요청이 있었으므로 결제요청테이블에서 취소로 업데이트
            {
              this.updReqPay();
            }
            else                              // 결제요청이 없었으므로 결제요청자료를 취소로 생성
            {
              this.insReqPay();
            }
          }
          
          let insDate = this.getNowDateTime();
          let oldComment = this.reserveInfo.oldComment;
          let newComment = this.reserveInfo.newComment;
          let insComment = oldComment +'\n'+ "["+ this.user.handlerId +":"+ insDate +"]: "+ newComment;

          this.$swal.fire({
          icon: 'question',
          text: '예약정보를 저장하겠습니까?',
          showCancelButton: true,
          confirmButtonText: '저장',
          cancelButtonText: '취소'
          }).then(async (result) => 
          {
            if (result.isConfirmed) 
            {
              //예약취소인 경우, 취소요청이 들어온 예약인지 체크
              if(this.reserveInfo.reqStatus == "CX")
              {
                // 취소에 따라 재고복구
                await this.update_selOptQty(this.reqRsvCode)

                // 구매통계에 취소반영
                if(this.userPayInfo.payFlag === "fu" || this.userPayInfo.payFlag === "p2" || this.userPayInfo.payFlag == undefined)
                {
                  //일반구매카운트
                  await this.countPageView_cxl(this.productInfo.salesRoute, this.productId)
                  //연계플래그가 있으면 카운트
                  if(this.productInfo.assoFlag != undefined && this.productInfo.assoFlag != "" && this.productInfo.assoFlag != null)
                  {
                    //연계구매카운트
                    await this.countPageView_asso_cxl(this.productId, this.productInfo.assoFlag)
                  }
                }

                let checkReqCxl1 = await this.$api("/api/checkReqCxl", {param: [this.reqRsvCode]});
                if(checkReqCxl1.length > 0)
                {
                  this.reqCxlHandling(this.reqRsvCode)
                }
              }

              //포인트 결제가 있으면 처리한다(>0)
              if(this.paidPoint > 0)
              {
                let payByPoint = await this.$api("/api/payByPoint", {param: [
                  this.reserveInfo.reqEmail,this.paidPoint,'U',this.reqRsvCode,''
                ]});
                if(Object.keys(payByPoint)[0] === 'error') 
                {
                  this.$swal.fire('', '포인트 결제처리 중 오류가 발생하였습니다.<br>관리자에게 문의해 주세요.', 'error');
                  return false;
                }
              }

              if(this.reserveInfo.payPoint > 0)
              {
                this.paidPoint = this.reserveInfo.payPoint;
              }

              if(changedFlag === "Y")
              {
                this.reserveInfo.rCopyFlag = "Y"
              }              

              let upd_reserve_m = await this.$api("/api/upd_reserve_m_new_new", {param: [
                this.reserveInfo.reqStatus, this.user.handlerId, this.reserveInfo.reqName, this.reserveInfo.reqTelNo,
                this.reserveInfo.rCopyFlag,  this.reserveInfo.conEmail,
                this.reserveInfo.cxlFlag,
                insComment,
                this.reqRsvCode
              ]});
              if(upd_reserve_m.affectedRows < 0 || upd_reserve_m.affectedRows === undefined)
              {
                this.$swal.fire('', '정보변경작업(upd_reserve_m) 중 오류가 발생하였습니다.', 'error');
                return false;
              }
              else
              {
                this.$swal.fire('', '정보변경작업이 완료되었습니다.', 'success');
                //카톡자동발송코드
                this.sendKakao(this.reserveInfo.reqStatus, this.reserveInfo.resMFlag)
              }
            }
          })
        }
      }
      else if (p1==="M" && p2 ==="P")
      {
        // 상담가격 재계산 후 업데이트 진행
        this.calcCstPrice();
      }
    },

    //옵션수량 복구
    async update_selOptQty(oId) {
      let updFlag = 'P'
      let upd_selOptQty = await this.$api("/api/proc_updOptSel_qty", {param: [oId, updFlag]})
      if(upd_selOptQty.affectedRows <1)
      {
        this.$swal.fire('','<b class="text-danger">죄송합니다</b><br>재고복구 처리 중 문제가 발생했습니다.', 'warning')
        return false;
      }

      // 추가상품 구매가 있다면, 추가상품 재고도 복구
      if(this.addPdtFlag == "Y") 
      {
        let upd_addPdtQty = await this.$api("/api/proc_updAddPdt_qty", {param: [oId, updFlag]})
        if(upd_addPdtQty.affectedRows <1)
        {
          this.$swal.fire('','<b class="text-danger">죄송합니다</b><br>추가상품 재고복구 처리 중 문제가 발생했습니다.', 'warning')
          return false;
        }
      }
    },

    //결제요청 정보처리
    async insReqPay()
    {
      
      let insReqPayInfo = await this.$api("/api/insReqPayInfo",{param: [
        this.reqRsvCode,this.reserveInfo.reqStatus,this.cstPrice,'N',this.user.handlerId
      ]});
      if(Object.keys(insReqPayInfo)[0] === 'error') 
      {
        this.$swal.fire('','처리 중 오류발생(insReqPayInfo)<br>관리자에게 문의하세요', 'error')
        return false;
      }
    },
    async updReqPay()
    {
      let updReqPayInfo = await this.$api("/api/updReqPayInfo",{param: [
        this.reserveInfo.reqStatus,this.cstPrice,this.user.handlerId,this.reqRsvCode
      ]});
      if(updReqPayInfo.affectedRows < 0 || updReqPayInfo.affectedRows === undefined)
      {
        this.$swal.fire('','처리 중 오류발생(updReqPayInfo)<br>관리자에게 문의하세요', 'error')
        return false;
      }
    },
    //고객취소요청예약인 경우, 마이페이지용 처리
    async reqCxlHandling(rCode)
    {
      let upd_reqCxl = await this.$api("/api/upd_reqCxl", {param: [
        this.user.handlerId,'Y',rCode
      ]});
      if(upd_reqCxl.affectedRows < 0 || upd_reqCxl.affectedRows === undefined)
      {
        this.$swal.fire('', '예약취소 중 중 오류가 발생하였습니다.', 'error');
        return false;
      }      
    },

    getDateFormat(date) {
      return this.$dateFormat(date);
    },
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    //한국표준시로 변경
    getKorDateFormat(date) {
      return this.$korDateFormat(date)
    },
  }
}
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

.admin-page {
  --ink: #0f1720;
  --muted: #3d4652;
  --paper: #f4f6f8;
  --card: #ffffff;
  --line: #d7dce2;
  --accent: #0a6169;
  --accent-soft: #dcf0ef;
  --warn: #a85f14;
  --warn-soft: #fbe8cf;
  --danger: #a52e27;
  --danger-soft: #f8dad8;
  --success: #1f6e44;
  --success-soft: #d9f0e4;

  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Malgun Gothic', sans-serif;
  color: var(--ink);
  background: var(--paper);
  padding-bottom: 2rem;
  font-size: 1rem;
}

/* ---------- 상단 액션바 ---------- */
.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background: var(--card);
  border-bottom: 1px solid var(--line);
  padding: 0.85rem 1.25rem;
  box-shadow: 0 2px 8px rgba(20, 30, 40, 0.06);
}
.topbar-left { display: flex; align-items: center; gap: 0.6rem; }
.page-title {
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  margin: 0;
  color: var(--ink);
}
.topbar-right { display: flex; gap: 0.5rem; }

.badge-pill {
  display: inline-block;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}
.badge-nonmember { background: var(--success-soft); color: var(--success); }
.badge-membership { background: var(--warn-soft); color: var(--warn); }
.badge-pending { background: var(--danger-soft); color: var(--danger); }

.btn-calc, .btn-save, .btn-list, .btn-point-add, .btn-request-balance {
  border: none;
  border-radius: 8px;
  font-weight: 600;
  padding: 0.45rem 0.9rem;
  font-size: 0.85rem;
  transition: transform 0.08s ease, box-shadow 0.15s ease;
}
.btn-calc { background: var(--paper); color: var(--ink); border: 1px solid var(--line); }
.btn-save { background: var(--accent); color: #fff; }
.btn-save:hover, .btn-calc:hover { transform: translateY(-1px); }
.btn-list { background: var(--accent); color: #fff; padding: 0.6rem 2rem; border-radius: 8px; font-weight: 700; }
.btn-point-add { background: var(--success); color: #fff; border-radius: 6px; padding: 0.25rem 0.6rem; font-size: 0.78rem; }
.btn-request-balance { background: var(--success); color: #fff; }

/* ---------- 섹션 카드 ---------- */
.section-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 12px;
  margin-bottom: 1.25rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(20, 30, 40, 0.04);
}
.section-head {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.1rem;
  background: var(--accent-soft);
  border-bottom: 1px solid var(--line);
  border-left: 4px solid var(--accent);
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--accent);
  text-align: left;
}
.section-head-payment {
  background: var(--warn-soft);
  border-left-color: var(--warn);
  color: var(--warn);
}
.section-head i { font-size: 1rem; }

.data-table { margin-bottom: 0; border: none; }
.data-table th {
  background: #f0f2f4 !important;
  color: var(--ink);
  font-weight: 700;
  font-size: 0.88rem;
  text-align: left;
  vertical-align: middle;
  border-color: var(--line) !important;
}
.data-table td {
  border-color: var(--line) !important;
  color: var(--ink);
  font-size: 0.92rem;
}

.req-mark { color: var(--danger); font-size: 0.5rem; vertical-align: top; }

/* ---------- 편집가능 vs 읽기전용 구분 (핵심) ---------- */
.field-editable {
  background: #fbfdff;
  border: 1px solid #b9d9dc !important;
  border-left: 3px solid var(--accent) !important;
  color: var(--ink);
}
.field-editable:focus {
  border-color: var(--accent) !important;
  box-shadow: 0 0 0 3px var(--accent-soft);
}
.field-editable.field-warn {
  border-left-color: var(--danger) !important;
  background: var(--danger-soft);
}

.field-readonly {
  background: transparent !important;
  border: none !important;
  border-bottom: 1px dashed #c3cad2 !important;
  border-radius: 0 !important;
  color: var(--ink);
  font-weight: 500;
  padding-left: 0.3rem;
}
.field-readonly:disabled, .field-readonly[readonly] { opacity: 1; -webkit-text-fill-color: var(--ink); }

.ref-value { color: var(--ink); font-weight: 700; }
.ref-code { font-family: 'SFMono-Regular', Consolas, monospace; letter-spacing: 0.03em; color: var(--accent); font-weight: 700; }
.text-muted-note { font-size: 0.74rem; color: var(--muted); font-weight: 500; }

/* ---------- 상태 배지 ---------- */
.status-chip {
  display: inline-block;
  padding: 0.25rem 0.7rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 800;
  background: #e4e7eb;
  color: var(--ink);
  white-space: nowrap;
}
.status-CO { background: var(--success-soft); color: var(--success); }
.status-CX { background: var(--danger-soft); color: var(--danger); }
.status-RP, .status-WP { background: var(--warn-soft); color: var(--warn); }
.status-PY { background: var(--accent-soft); color: var(--accent); }

/* ---------- 옵션/가격 ---------- */
.opt-cell { font-size: 0.85rem; }
.opt-label {
  font-weight: 700;
  font-size: 0.8rem;
  margin-top: 0.4rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.opt-label-select { color: var(--accent); }
.opt-label-direct { color: #5b6b9c; }
.opt-line { padding: 0.15rem 0; color: var(--ink); }
.opt-empty { color: var(--muted); font-style: italic; font-size: 0.87rem; font-weight: 500; }

.price-highlight {
  text-align: right;
  padding-right: 1rem;
  font-size: 1.25rem;
  font-weight: 800;
  color: var(--danger);
}

/* ---------- 결제 히스토리 ---------- */
.pay-block p, .pay-history p { margin-bottom: 0.35rem; font-size: 0.9rem; color: var(--ink); }
.hist-date { font-size: 0.8rem; color: var(--muted); font-weight: 600; }
.hist-total { font-weight: 800; color: var(--ink); float: right; }
.hint-danger { font-size: 0.78rem; color: var(--danger); font-weight: 700; margin: 0; }

@media (max-width: 768px) {
  .topbar { flex-direction: column; align-items: stretch; }
  .topbar-right { justify-content: flex-end; }
}
</style>